<template>
  <div >
   
    <div style="height: 50px;"/>

    <CardForm
      :form-data="formData"
      @submit="submit"
      @input-card-number="updateCardNumber"
      @input-card-name="updateCardName"
      @input-card-month="updateCardMonth"
      @input-card-year="updateCardYear"
      @input-card-cvv="updateCardCvv"
      @input-card-number-notmark="updateCardNumberNotMark"
    />
  </div>
</template>

<script>
import CardForm from '@/components/CardForm'
export default {
  name: 'creditcard',
  components: {
    CardForm
  },
  data () {
    return {
      formData: {
        cardName: '',
        cardNumber: '',
        cardNumberNotMask: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: ''
      }
    }
  },
  methods: {
    submit(){
      console.log(this.formData)
        this.$router.push({ path: `payment`,
         query: {
          aid: this.$route.params.aid,
          pt: this.$route.params.pt,
          type: this.$route.params.type,
          pid: this.$route.params.pid,
          at: this.$route.params.at,
          c: btoa(JSON.stringify(this.formData))
        }})
    },
    updateCardNumber (val) {
        this.formData.cardNumber = val
    },
    updateCardName (val) {
         this.formData.cardName = val
    },
    updateCardMonth (val) {
         this.formData.cardMonth = val
    },
    updateCardYear (val) {
         this.formData.cardYear = val
    },
    updateCardCvv (val) {
         this.formData.cardCvv = val
    },
    updateCardNumberNotMark (val) {

         this.formData.cardNumberNotMask = val
    }
  },

}
</script>


<style scoped lang="scss">
@import '../../src/assets/style.scss';
</style>